module.exports = __webpack_public_path__ + "img/icon_agreement_select@3x.fc8c8205.png";